import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { personService } from '@shared/services/personService';
import { notifyError } from '@config/tostifyConfig/tostifyConfig';

export default function RemotelyDocumentsForm({ person }) {
    const { t } = useTranslation();
    const [addressData, setAddressData] = useState([]);

    useEffect(() => {
        const fetchAddressData = async () => {
            try {
                if (person?.id) {
                    const data = await personService.getHomeOfficeAddress(person.id);
                    setAddressData(data);
                }
            } catch (error) {
                console.error('Error fetching address data:', error);
                notifyError(t('persons.remotelyDocuments.fetchError'));
            }
        };

        fetchAddressData();
    }, [person?.id]);

    return (
        <div className="remotely-documents-container">
            <h3 className="form-subtitle">
                {t('persons.remotelyDocuments.title', {
                    name: [person.name, person.fathersName, person.surname]
                        .filter(Boolean)
                        .join(' ')
                })}
            </h3>

            <div className="form-content">
                <div className="form-section">
                    <div className="icons-section">
                        <div className="icon-wrapper">
                            <img 
                                src="/images/logo/pdficon.gif" 
                                alt="Remotely Work"
                                className="document-icon"
                            />
                            <span className="icon-label">{t('persons.remotelyDocuments.additionalAgreement')}</span>
                        </div>
                        <div className="icon-wrapper">
                            <img 
                                src="/images/logo/pdficon.gif" 
                                alt="Home Office"
                                className="document-icon"
                            />
                            <span className="icon-label">{t('persons.remotelyDocuments.questionnaire')}</span>
                        </div>
                    </div>

                    <div className="remotely-form-controls">
                        <button 
                            type="button" 
                            className="form-btn btn-green"
                        >
                            {t('persons.remotelyDocuments.confirm')}
                        </button>
                    </div>
                </div>

                <div className="table-section">
                    <div className="remotely-list-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>{t('persons.remotelyDocuments.fromDate')}</th>
                                    <th>{t('persons.remotelyDocuments.address')}</th>
                                    <th>{t('persons.remotelyDocuments.agreementNumber')}</th>
                                    <th>{t('persons.remotelyDocuments.documentsReceived')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {addressData.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.dateEnter || '-'}</td>
                                        <td>{item.fullAddress}</td>
                                        <td>{item.annexNumber}</td>
                                        <td>
                                            {item.confirmation ? t('common.yes') : t('common.no')}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
} 